export default {
  "productPhotos": { "unsavedTitle":"Gardez vos changements ?","unsavedBody":"Enregistrer ou supprimer le paramètre photo du produit avant de quitter ce modèle.","save":"Enregistrer","discard":"Renonciation","cancel":"Annuler","saveFailed":"Les changements n'ont pas pu être sauvegardés. Votre réglage en attente a été maintenu. Veuillez réessayer.","label": "Afficher les photos de produit", "help": "Utilisez les photos déjà enregistrées contre les produits. Sauvez la mise en page pour garder ce réglage." },
  "copy0": "L'utilisation des recettes peut être saisie dans des unités compatibles avec",
  "copy1": "Pas de correspondance trouvée.",
  "copy2": "Nom",
  "copy3": "Barre principale",
  "copy4": "Type de sortie",
  "copy5": "Sélectionnez le type de sortie",
  "copy6": "Menus disponibles à cette sortie",
  "copy7": "Sélectionnez chaque menu que cette sortie peut servir, puis choisissez un menu par défaut.",
  "copy8": "De l ' ordre public",
  "copy9": "Mode de service",
  "copy10": "Mode de service",
  "copy11": "Service rapide",
  "copy12": "Service de la table",
  "copy13": "Sélection de la table",
  "copy14": "Sélectionnez l ' obligation",
  "copy15": "Obligatoire",
  "copy16": "Facultatif",
  "copy17": "Zones de restauration",
  "copy18": "Créez d'abord des espaces pour les assigner ici.",
  "copy19": "Inventaire",
  "copy20": "Situation facultative",
  "copy21": "Pas d'emplacement",
  "copy22": "Démarrage actif",
  "copy23": "Activer ou désactiver cette prise.",
  "copy24": "Annuler",
  "copy25": "Sauvegarder la sortie",
  "copy26": "Dîner salle à manger",
  "copy27": "Affectation de l ' envoi",
  "copy28": "Assigner ce menu aux sorties des paramètres Outlet.",
  "copy29": "Menu actif",
  "copy30": "Cacher ou publier ce menu.",
  "copy31": "Activer pour le service de chambre",
  "copy32": "Publier ce menu à des écrans dans la salle.",
  "copy33": "Surtaxe (%)",
  "copy34": "Frais de livraison",
  "copy35": "La surtaxe s'applique à chaque article de ce menu. Les frais de livraison s'appliquent une fois par commande dans une phase ultérieure.",
  "copy36": "Menu",
  "copy37": "Mettre à jour les éléments de ligne apparaissant sur ce menu.",
  "copy38": "Étiquette de bouton",
  "copy39": "Nom de l ' article",
  "copy40": "Taille du colis",
  "copy41": "Coût",
  "copy42": "Prix de vente",
  "copy43": "Actions",
  "copy44": "Pas encore d'articles de menu.",
  "copy45": "Célibataire",
  "copy46": "0,00",
  "copy47": "Double menu",
  "copy48": "Sauvegarder le menu",
  "copy49": "Retirer le menu?",
  "copy50": "Retirer",
  "copy51": "de ce menu.",
  "copy52": "Sélectionnez une sortie pour générer un lien de lancement.",
  "copy53": "Lien de lancement",
  "copy54": "URL de sortie sécurisée + tournant OTP .",
  "copy55": "URL de sortie",
  "copy56": "Code de passe unique",
  "copy57": "Expirant",
  "copy58": "Code QR en attente",
  "copy59": "Scanner pour ouvrir le terminal",
  "copy60": "Regénérer le secret terminal",
  "copy61": "Accès du personnel",
  "copy62": "Assignez le personnel du club à la connexion PIN cashier. Pin hashes stay server-side and old pins are never shown.",
  "copy63": "Rechercher le personnel affecté...",
  "copy64": "Ajouter le personnel",
  "copy65": "Affecté",
  "copy66": "Jeu pIN",
  "copy67": "Dernière connexion :",
  "copy68": "Niveau des autorisations",
  "copy69": "Norme standard",
  "copy70": "Améliorés",
  "copy71": "Générer/réinitialiser le NIP",
  "copy72": "Supprimer de l ' ePOS",
  "copy73": "Accès aux sorties",
  "copy74": "Toutes les sorties",
  "copy75": "Ce fonctionnaire peut se connecter à tous les points de vente du POS.",
  "copy76": "Aucun personnel n ' est affecté à l ' EPOS.",
  "copy77": "Ajouter le personnel d ' epos",
  "copy78": "Sélectionnez un ou plusieurs membres actifs du club. L'affectation ne modifie pas leur compte de base du personnel.",
  "copy79": "Rechercher le personnel admissible...",
  "copy80": "Assigner sélectionné",
  "copy81": "Nouveau PIN POS",
  "copy82": "Ce NIP n'est montré qu'une seule fois. Il ne peut pas être récupéré plus tard.",
  "copy83": "Copie épingle",
  "copy84": "Terminé",
  "copy85": "n'a pas le module ePOS Management activé.",
  "copy86": "Assistant de configuration",
  "copy87": "Créer une sortie",
  "copy88": "Créer un menu",
  "copy89": "Sorties actives",
  "copy90": "Les points de vente en direct acceptent actuellement les ordres.",
  "copy91": "Menus actifs",
  "copy92": "Menus assignés aux prises et activés.",
  "copy93": "Boutons configurés",
  "copy94": "Boutons configurés sur le menu sélectionné.",
  "copy95": "Des tracts en un coup d'oeil",
  "copy96": "Accélérez rapidement dans les liens de lancement et l'état.",
  "copy97": "Pas encore de sorties",
  "copy98": "Créez votre première sortie pour commencer les menus de construction.",
  "copy99": "Lien de lancement",
  "copy100": "Sorties",
  "copy101": "Actualiser",
  "copy102": "Gérer les emplacements de service et les défauts.",
  "copy103": "Installez un bar, une salle à manger ou un magasin professionnel.",
  "copy104": "Mis à jour",
  "copy105": "Éditer la sortie",
  "copy106": "Détails de sortie",
  "copy107": "Cartes de menu par défaut et d'inventaire.",
  "copy108": "Menu par défaut",
  "copy109": "Sortie",
  "copy110": "Emplacement de l ' inventaire",
  "copy111": "Stock",
  "copy112": "Menus",
  "copy113": "Assigner les menus aux prises et les maintenir en courant.",
  "copy114": "Pas encore de menus",
  "copy115": "Créez votre premier menu et commencez à ajouter des boutons.",
  "copy116": "Sélecteur de menu",
  "copy117": "Sélectionnez un menu",
  "copy118": "points de vente)",
  "copy119": "Modifier le menu",
  "copy120": "Duplicata",
  "copy121": "Menu du constructeur",
  "copy122": "Concevez la grille de bouton pour le menu sélectionné.",
  "copy123": "Point",
  "copy124": "configuré.",
  "copy125": "Choisissez un menu pour commencer les boutons de configuration.",
  "copy126": "Tous les produits ePOS actifs",
  "copy127": "Parcourir, filtrer, cocher plusieurs produits, puis les ajouter ensemble.",
  "copy128": "Ajouter sélectionné",
  "copy129": "Produits de recherche rapide...",
  "copy130": "Catégorie",
  "copy131": "Recherche d'articles...",
  "copy132": "Ajouté",
  "copy133": "Boutons",
  "copy134": "Les boutons de menu ne pouvaient pas charger.",
  "copy135": "Ce menu n'a pas de boutons",
  "copy136": "Rechercher des produits ePOS actifs ci-dessus, puis appuyez sur Ajouter pour construire votre grille POS.",
  "copy137": "Ajouter des objets",
  "copy138": "Numéro manquant de l'inventaire.",
  "copy139": "Article inactif ou non commercialisable.",
  "copy140": "epos produits",
  "copy141": "Les produits sont ce que les membres et les invités achètent à la caisse; les recettes manipulent la consommation de stock.",
  "copy142": "Créer un produit",
  "copy143": "Les produits sont temporairement indisponibles.",
  "copy144": "Nom du produit*",
  "copy145": "Nom du produit",
  "copy146": "p.ex. Carling Pint",
  "copy147": "Coiffe de bière",
  "copy148": "Prix de vente indiqué au membre/l'invité",
  "copy149": "Prix de vente",
  "copy150": "6.50",
  "copy151": "Le prix de vente comprend VAT ?",
  "copy152": "Oui",
  "copy153": "Non",
  "copy154": "Code fiscal",
  "copy155": "Élément de stock lié (recette commodité seulement)",
  "copy156": "Sélectionner l'article",
  "copy157": "Pas de recette liée",
  "copy158": "Image de produit",
  "copy159": "Téléchargement de l'image de produit",
  "copy160": "Envoyer à KDS / nécessite la préparation",
  "copy161": "Par défaut, c'est pour la sécurité. Les produits marqués comme nécessitant des règles de routage KDS.",
  "copy162": "Catégorie prép",
  "copy163": "Éditer en inventaire",
  "copy164": "Modifier",
  "copy165": "Désactiver",
  "copy166": "Créer une recette",
  "copy167": "Pas encore de produits ePOS",
  "copy168": "Créez Carling Pint, Bouteille de Coke, Cheeseburger, et d'autres boutons jusqu'ici.",
  "copy169": "Recettes",
  "copy170": "Les recettes définissent les articles d'inventaire consommés lorsqu'un produit POS est vendu.",
  "copy171": "Les recettes sont temporairement indisponibles.",
  "copy172": "Choisissez un produit et définissez le stock consommé par vente.",
  "copy173": "Annuler la modification",
  "copy174": "Produit*",
  "copy175": "Sélectionnez le produit ePOS",
  "copy176": "Recherche de produits par nom, SKU , code d'article, catégorie, sous-catégorie, ou unité...",
  "copy177": "Ingrédients / inventaire consommé",
  "copy178": "Ajouter l'ingrédient",
  "copy179": "Article suivi en stock",
  "copy180": "Recherche d'articles par nom, SKU , code d'article, catégorie, sous-catégorie, ou unité...",
  "copy181": "Quantité consommée",
  "copy182": "568",
  "copy183": "Modifier les lignes",
  "copy184": "Pas encore de recettes",
  "copy185": "Utilisez l'assistant de configuration ou créez un produit, puis définissez le stock qu'il consomme.",
  "copy186": "ePOS transactions",
  "copy187": "Commandes/vérifications/abs et relevés de vente/paiement complets avec traçabilité de l'inventaire.",
  "copy188": "Date de la transaction",
  "copy189": "Date de transaction",
  "copy190": "Sortie de transaction",
  "copy191": "État de la transaction",
  "copy192": "Statut",
  "copy193": "Statut par défaut",
  "copy194": "Commandes actives",
  "copy195": "Ouvrir",
  "copy196": "Versement en attente",
  "copy197": "Envoyé à la cuisine",
  "copy198": "Non payé",
  "copy199": "Payés / terminés",
  "copy200": "Annulés",
  "copy201": "Remboursé",
  "copy202": "Annulé",
  "copy203": "Recherche de transactions",
  "copy204": "Recherche vente, table, produit",
  "copy205": "Réinitialiser les filtres",
  "copy206": "Ordres",
  "copy207": "Ventes",
  "copy208": "Chargement des transactions...",
  "copy209": "Voir détail",
  "copy210": "Aucune commande opérationnelle trouvée pour les filtres sélectionnés.",
  "copy211": "Aucune vente n'a été trouvée pour les filtres sélectionnés.",
  "copy212": "Charger le détail...",
  "copy213": "Nombre",
  "copy214": "Tableau",
  "copy215": "Personnel / caissier",
  "copy216": "Total",
  "copy217": "Sous-total",
  "copy218": "Taxe",
  "copy219": "Articles de ligne",
  "copy220": "Qté",
  "copy221": "Aucun élément de ligne n ' a été enregistré.",
  "copy222": "Paiements",
  "copy223": "Aucun paiement enregistré.",
  "copy224": "Résumé",
  "copy225": "Original",
  "copy226": "• En attente",
  "copy227": "Résumé de l ' allocation des paiements",
  "copy228": "Incidences sur le compte des membres",
  "copy229": "Ventilation fiscale",
  "copy230": "Résumé du GL",
  "copy231": "Débits",
  "copy232": "Crédits",
  "copy233": "Dr.",
  "copy234": "• Cr",
  "copy235": "Résumé de la consommation",
  "copy236": "Quantité",
  "copy237": "• Quantité de recettes",
  "copy238": "Modifier le produit ePOS",
  "copy239": "Mettre à jour les détails du produit affichés aux membres et aux invités.",
  "copy240": "Modifier le nom du produit",
  "copy241": "Modifier le prix de vente",
  "copy242": "Article de stock lié",
  "copy243": "Pas de lien de stock direct",
  "copy244": "Aperçu du produit",
  "copy245": "Aucune image",
  "copy246": "Modifier l'image du produit télécharger",
  "copy247": "Les produits marqués comme nécessitant KDS seront envoyés à la première route active correspondante.",
  "copy248": "Active / vendable",
  "copy249": "Sauvegarder le produit",
  "copy250": "Désactiver le produit ?",
  "copy251": "Cela supprime le produit de la sélection active ePOS mais conserve son histoire.",
  "copy252": "Inventaire / ePOS Wizard de configuration",
  "copy253": "Stock produit = ce que le club achète/magasine. ePOS produit = ce que le membre/l'invité achète. Recette = combien de stock est consommé par vente, p.ex. stock a 30 L keg, vendre une pincée, et consommer 568 ml de keg stock.",
  "copy254": "Qu'est-ce que tu prépares ?",
  "copy255": "L'assistant est déterministe: il utilise seulement les champs ci-dessous. Des suggestions assistées par AI sont disponibles plus tard derrière le drapeau de la fonctionnalité désactivée.",
  "copy256": "Nom du produit*",
  "copy257": "Par exemple, le fût de 30 L",
  "copy258": "SKU / code-barres / code d'article",
  "copy259": "Bière",
  "copy260": "Achats",
  "copy261": "Quantité d'achat / taille",
  "copy262": "30",
  "copy263": "Unité de taille d ' achat",
  "copy264": "Prix du fournisseur",
  "copy265": "100.00",
  "copy266": "Code fiscal d ' achat",
  "copy267": "Code fiscal facultatif id",
  "copy268": "ePOS nom du produit*",
  "copy269": "e.g. Produit Pint",
  "copy270": "Consommez une unité de stock par vente?",
  "copy271": "Oui, consommez 1 chacun",
  "copy272": "Non, je vais définir des lignes de recettes",
  "copy273": "Taille du service consommée",
  "copy274": "Unité de service",
  "copy275": "Produit existant de l ' EPOS*",
  "copy276": "Sélectionnez le produit",
  "copy277": "Ingrédients de recettes",
  "copy278": "1",
  "copy279": "Créer une configuration",
  "copy280": "Vente actuelle",
  "copy281": "Tableau d ' affectation",
  "copy282": "Effacer",
  "copy283": "Supprimer l ' élément sélectionné",
  "copy284": "Articles",
  "copy285": "VAT inclus",
  "copy286": "Solde",
  "copy287": "Terminal POS",
  "copy288": "Vente en cours clair ?",
  "copy289": "Annuler la vente libre",
  "copy290": "Cela supprimera l'affectation actuelle de la table et effacera la vente de ce terminal.",
  "copy291": "Envoyer à la cuisine",
  "copy292": "Fermer",
  "copy293": "Prép notes",
  "copy294": "Ajouter les notes de prép (facultatif)",
  "copy295": "Feu maintenant",
  "copy296": "Entrée en code-barres manuel",
  "copy297": "Scanners USB/Bluetooth et entrée manuelle pris en charge.",
  "copy298": "Fermer l'entrée en code barre",
  "copy299": "Scan ou code barre de type",
  "copy300": "Scanner de refocus",
  "copy301": "Dernière balayée :",
  "copy302": "· Ajouté",
  "copy303": "Verrouillage",
  "copy304": "Login personnel",
  "copy305": "S'identifier au personnel — Entrez votre code à 4 chiffres pour accéder",
  "copy306": "Personnel PIN",
  "copy307": "Supprimer",
  "copy308": "Personnel :",
  "copy309": "Options de terminaux ouverts",
  "copy310": "Options de terminaux",
  "copy311": "Fermer les options terminales",
  "copy312": "Choisissez s'il faut déconnecter le membre actuel du personnel ou verrouiller ce terminal.",
  "copy313": "Déconnexion",
  "copy314": "Écran de verrouillage",
  "copy315": "Menu",
  "copy316": "Tableaux",
  "copy317": "Ouvrez l ' entrée du code-barres manuel",
  "copy318": "Scan / Code barre",
  "copy319": "Sélectionnez une table pour commencer.",
  "copy320": "Mode de vue de la table",
  "copy321": "Tuiles",
  "copy322": "Plan de plancher",
  "copy323": "Aucune salle à manger n'est assignée à cette sortie.",
  "copy324": "Pas encore de tables dans ce domaine.",
  "copy325": "occupés",
  "copy326": "Paiement",
  "copy327": "Total",
  "copy328": "Carte",
  "copy329": "Paye (Card Present)",
  "copy330": "Encaisse",
  "copy331": "Instantané.",
  "copy332": "Membre",
  "copy333": "Lecteur simulé (mode d'essai)",
  "copy334": "Préparer une nouvelle vente...",
  "copy335": "v",
  "copy336": "Mise à jour",
  "copy337": "Affecté :",
  "copy338": "Publication",
  "copy339": "Archiver",
  "copy340": "Modifier le modèle",
  "copy341": "Gérer les détails de modèle, l'état de cycle de vie et la sécurité d'assignation de sortie.",
  "copy342": "Nom du modèle",
  "copy343": "Description",
  "copy344": "Taille du terminal par défaut",
  "copy345": "Points de vente assignés",
  "copy346": "La suppression d'un gabarit désactive ces cessions avant l'enlèvement de sorte que les sorties tombent en toute sécurité dans leur prochain modèle ou menu historique disponible.",
  "copy347": "Dépublier en brouillon",
  "copy348": "Restauration au projet",
  "copy349": "Supprimer le modèle",
  "copy350": "Enregistrer",
  "copy351": "Supprimer le modèle POS",
  "copy352": "Confirmez la suppression de ce modèle de concepteur d'écran POS.",
  "copy353": "Modèle :",
  "copy354": "Toute cession de sortie active pour ce modèle sera désactivée avant que le modèle ne soit supprimé.",
  "copy355": "Les liens de gabarit d'enfant et les références de lignée copiée-modèle seront détachés de sorte que les modèles connexes restent disponibles.",
  "copy356": "Dossier ·",
  "copy357": "Points",
  "copy358": "W+",
  "copy359": "W...",
  "copy360": "H+",
  "copy361": "H...",
  "copy362": "Privana Aide",
  "copy363": "Privana Aider l'instruction de mise en page du SOP",
  "copy364": "Décrivez l'écran POS que vous voulez construire ou améliorer...",
  "copy365": "Concevoir...",
  "copy366": "Soumettre",
  "copy367": "Privana conçoit votre écran...",
  "copy368": "Réviser et raffiner vos produits, pages et mise en page tactile.",
  "copy369": "Proposition prête à l ' examen",
  "copy370": "Proposition d ' examen",
  "copy371": "Régénérer",
  "copy372": "Changer de produit",
  "copy373": "Annuler la proposition",
  "copy374": "Annuler la proposition",
  "copy375": "Choisissez des produits pour cet écran POS",
  "copy376": "Sélectionnez jusqu'à 100 produits pour Privana Aider à organiser.",
  "copy377": "Recherche produits",
  "copy378": "Recherche par nom de produit, SKU ou code-barres",
  "copy379": "produit",
  "copy380": "montrée",
  "copy381": "Sélectionnez visible",
  "copy382": "Sélection claire",
  "copy383": "Aucun produit ePOS admissible n'est disponible.",
  "copy384": "Aucun produit ne correspond à votre recherche.",
  "copy385": "de 100 sélectionnés",
  "copy386": "Cette confirmation utilise votre modèle et les produits sélectionnés. La génération n’a pas encore commencé.",
  "copy387": "Je vais optimiser pour :",
  "copy388": "Objectif de conception",
  "copy389": "(facultatif)",
  "copy390": "Retour",
  "copy391": "Modifier le type de détail",
  "copy392": "Pourquoi Privana a recommandé cette mise en page",
  "copy393": "Confiance d ' abandon",
  "copy394": "Recommandations",
  "copy395": "Mode:",
  "copy396": "Appareil:",
  "copy397": "Enlèvement",
  "copy398": "pages,",
  "copy399": "nœuds et",
  "copy400": "boutons.",
  "copy401": "Pourquoi Privana l'a conçu de cette façon",
  "copy402": "Outils de concepteur d'écran POS",
  "copy403": "Agrandir designer sidebar",
  "copy404": "Étendre la barre latérale",
  "copy405": "Concepteur d’écran de caisse",
  "copy406": "Construisez des écrans tactiles de vos produits et menus en direct.",
  "copy407": "S'effondrer sidebar",
  "copy408": "Effondrement de la barre latérale",
  "copy409": "Outils design",
  "copy410": "Créer un modèle",
  "copy411": "Générer le démarreur dans les menus",
  "copy412": "Les affectations de sortie remplacent la chute de toutes les sorties.",
  "copy413": "Assigner à tous les points de vente",
  "copy414": "Assigner",
  "copy415": "Pages",
  "copy416": "Debout",
  "copy417": "En bas.",
  "copy418": "Liés par",
  "copy419": "bouton de dossier",
  "copy420": "; la suppression les fait retomber à la mise en page d'auto enfant-noe.",
  "copy421": "Produits",
  "copy422": "Dossiers",
  "copy423": "Bouton de dossier",
  "copy424": "Bientôt",
  "copy425": "Contenu dynamique",
  "copy426": "Propriétés",
  "copy427": "Le thème, la mise en page et les paramètres de bouton/node sélectionnés.",
  "copy428": "Contexte thématique",
  "copy429": "Bouton sélectionné",
  "copy430": "Couleur de bouton",
  "copy431": "x",
  "copy432": ", y",
  "copy433": ", w",
  "copy434": ", h",
  "copy435": "Rien n'est sélectionné",
  "copy436": "Sélectionnez un bouton de toile ou un nœud de navigation pour modifier ses propriétés.",
  "copy437": "Node sélectionné",
  "copy438": "Page dessinée",
  "copy439": "Pas de page",
  "copy440": "Principales mesures",
  "copy441": "Clé de source dynamique",
  "copy442": "Dossier pour enfants",
  "copy443": "Produit Enfant",
  "copy444": "Supprimer node",
  "copy445": "Arbre de navigation",
  "copy446": "POS toile workspace",
  "copy447": "Éditer les actions",
  "copy448": "Page",
  "copy449": "Sauvegarder la mise en page",
  "copy450": "grille visible;",
  "copy451": "rangées défilantes",
  "copy452": "Commencez à construire cette page",
  "copy453": "Faites glisser un article de la Bibliothèque sur la toile.",
  "copy454": "État de la toile",
  "copy455": "colonnes",
  "copy456": "rangées visibles",
  "copy457": "lignes logiques",
  "copy458": "Privana",
  "copy459": "Membre (facultatif)",
  "copy460": "Joindre un membre pour l'attribution & les reçus.",
  "copy461": "Appliquée",
  "copy462": "Numéro de membre",
  "copy463": "Chargement du plan de sol...",
  "copy464": "Table sélectionnée Centre",
  "copy465": "Centre sélectionné",
  "copy466": "Zoom sur le plan plancher",
  "copy467": "Plan de plancher encastré",
  "copy468": "Ajustement",
  "copy469": "Zoom sur le plan plancher",
  "copy470": "Plan d'étage statut légende",
  "copy471": "Disponible",
  "copy472": "Sélectionné",
  "copy473": "Non lié",
  "copy474": "Zone",
  "copy475": "Résumé de la zone de fermeture",
  "copy476": "Sièges",
  "copy477": "Pas de tables liées dans cette zone",
  "copy478": "Ce plan d'étage n'a pas encore de tableaux visuels liés. Les carreaux sont toujours disponibles.",
  "extra0": "Bar",
  "extra1": "Salle à manger",
  "extra2": "Pro Shop",
  "extra3": "Maison à mi-chemin",
  "extra4": "Cette question",
  "extra5": " ou ",
  "extra6": "Oui",
  "extra7": "Non",
  "extra8": "Libre-service par code QR",
  "extra9": "Paiement",
  "extra10": "Stock seulement",
  "extra11": "Produit simple acheté et vendu as-is",
  "extra12": "Bière de bureau / boisson mesurée",
  "extra13": "Recette / article alimentaire",
  "extra14": "Choisissez un mode de configuration.",
  "extra15": "Le nom de l'élément d'inventaire est requis.",
  "extra16": "Sélectionnez un produit ePOS existant.",
  "extra17": "Le nom du produit est requis.",
  "extra18": "Le prix de vente doit être nul ou supérieur.",
  "extra19": "La quantité de consommation doit être supérieure à zéro.",
  "extra20": "Ajouter au moins un ingrédient de la recette ou passer à une consommation.",
  "extra21": "Ajouter au moins un ingrédient de la recette.",
  "extra22": "Sélectionnez l'option",
  "extra26": "Modifier le point de sortie",
  "extra27": "Créer Outlet",
  "extra28": "Menu sans titre",
  "extra29": "Actif",
  "extra30": "Inactif",
  "extra31": "Emplacement de l ' inventaire",
  "extra32": "Impossible de charger les éléments du menu",
  "extra33": "Supplément non valide",
  "extra34": "Le supplément doit être compris entre 0 et 100.",
  "extra35": "Frais de livraison non valides",
  "extra36": "Les frais de livraison doivent être de 0 ou plus.",
  "extra37": "Menu objet mis à jour",
  "extra38": "Impossible de mettre à jour l'élément de menu",
  "extra39": "Article de menu enlevé",
  "extra40": "Impossible de supprimer l'élément de menu",
  "extra41": "Modifier le menu",
  "extra42": "Créer un menu",
  "extra43": "Enregistrer",
  "extra44": "cette question",
  "extra45": "Lien de sortie non prêt",
  "extra46": "Copier l'URL",
  "extra47": "Incapable de charger le personnel du SP",
  "extra48": "Veuillez réessayer.",
  "extra49": "Incapable de charger le personnel admissible",
  "extra50": "Incapable d ' assigner du personnel",
  "extra51": "Incapable d ' économiser l ' accès du personnel",
  "extra52": "Incapable de réinitialiser PIN",
  "extra53": "PIN copié",
  "extra54": "Partagez-le en toute sécurité avec le fonctionnaire.",
  "extra55": "Activé",
  "extra56": "Désactivé",
  "extra57": "Fonctionnaire du club",
  "extra59": "Jamais",
  "extra60": "Désactiver",
  "extra61": "Activer",
  "extra62": "Sélectionnez le produit",
  "extra63": "Recette prête",
  "extra64": "Aucune recette",
  "extra65": "Sélectionner l'article",
  "extra66": "Veuillez réessayer prochainement.",
  "extra67": "Incapables aux prises de charge",
  "extra68": "Impossible de charger des menus",
  "extra69": "Incapable de charger des articles suivis par le stock",
  "extra70": "Emplacements d ' inventaire non disponibles",
  "extra71": "Zones d ' aspiration non disponibles",
  "extra72": "Recherche échouée",
  "extra76": "Mise à jour",
  "extra77": "Outlet créé",
  "extra78": "Incapable pour Enregistrer la sortie",
  "extra79": "Menu mis à jour",
  "extra80": "Menu créé",
  "extra81": "Incapable d'enregistrer le menu",
  "extra82": "Menu dupliqué",
  "extra83": "Duplicata a échoué",
  "extra84": "Nom du produit requis",
  "extra85": "Le prix de vente doit être nul ou supérieur",
  "extra86": "Produit créé",
  "extra87": "Incapable de créer un produit",
  "extra88": "Produit mis à jour",
  "extra89": "Impossible de mettre à jour le produit",
  "extra90": "Produit désactivé",
  "extra91": "Ce produit est actuellement utilisé dans un menu. Retirez-le des menus avant de désactiver, ou essayez de nouveau après la mise à jour du menu.",
  "extra92": "Incapable de désactiver le produit",
  "extra93": "Sélectionnez un produit.",
  "extra94": "Ajouter au moins une ligne de recettes.",
  "extra95": "Sélectionnez un article suivi en stock.",
  "extra96": "Entrez une quantité supérieure à zéro.",
  "extra97": "Sélectionnez une unité.",
  "extra98": "Les lignes d'ingrédients ou d'unités doubles ne sont pas supportées.",
  "extra100": "Validation de la recette échouée",
  "extra101": "Fixez les champs de recettes surlignés.",
  "extra102": "Recette mise à jour",
  "extra103": "Recette enregistrée",
  "extra104": "Incapable d'économiser de la recette",
  "extra105": "Aucun nouvel article sélectionné",
  "extra106": "Les articles sélectionnés sont déjà dans ce menu.",
  "extra107": "Produits ajoutés au menu",
  "extra108": "Impossible d'ajouter des éléments sélectionnés",
  "extra109": "Impossible de mettre à jour l'étiquette",
  "extra110": "Impossible de supprimer l'élément de menu",
  "extra111": "Incapable de réordre",
  "extra112": "Incapable de chercher OTP",
  "extra113": "Terminal secret régénéré",
  "extra114": "Incapable de régénérer secret",
  "extra115": "Incapable de charger des transactions ePOS.",
  "extra116": "Incapable de charger les détails de transaction.",
  "extra117": "Ce club",
  "extra118": "Sans titre",
  "extra119": "Terminal de sortie ouvert",
  "extra121": "Non défini",
  "extra122": "Non liée",
  "extra123": "Menu désaffecté",
  "extra124": "Recette",
  "extra125": "Stock lié",
  "extra126": "Pas de recette",
  "extra127": "produit ePOS",
  "extra129": "Article sans nom",
  "extra130": "Catégorie de produit",
  "extra131": "Code fiscal",
  "extra132": "Alimentation",
  "extra133": "Bois",
  "extra134": "Dessert",
  "extra135": "Cuisine",
  "extra136": "Autre",
  "extra137": "Géré à partir de l ' inventaire",
  "extra138": "Consume 1 unité de stock",
  "extra139": "Vendable",
  "extra140": "Modifier les lignes de recettes",
  "extra141": "Créer une recette",
  "extra142": "Mettre à jour la recette",
  "extra143": "Save recette",
  "extra144": "Sortie",
  "extra145": "Ouvert",
  "extra146": "Statut",
  "extra147": "Sous-total",
  "extra148": "Taxe",
  "extra149": "Total",
  "extra150": "Personnel",
  "extra151": "Action",
  "extra152": "Invité",
  "extra153": "Vente",
  "extra154": "Heure",
  "extra155": "Produits vendus",
  "extra156": "Qté",
  "extra157": "Montant brut",
  "extra158": "Montant net",
  "extra159": "Stocks",
  "extra160": "Comptabilité",
  "extra161": "POS Vente en détail",
  "extra162": "Détail de la commande en caisse",
  "extra163": "Sommaire de la vente opérationnelle avec les paiements, la réalisation et l'état comptable.",
  "extra164": "Récapitulatif de l ' ordre opérationnel et de la vérification pour le personnel et les gestionnaires.",
  "extra165": "Membre",
  "extra166": "Vente à vendre",
  "extra167": "Membre / invité",
  "extra168": "Article",
  "extra169": "Affectation des crédits votés",
  "extra170": "Affecté",
  "extra171": "Frais de membre",
  "extra172": "Compte GL",
  "extra173": "Stock",
  "extra174": "Consommation",
  "extra175": "Modifier la catégorie des produits",
  "extra176": "Modifier le code fiscal",
  "extra177": "Validation de l'assistant de configuration échouée",
  "extra178": "Configuration créée",
  "extra179": "L'assistant de configuration a échoué",
  "extra180": "Table non trouvée. Rafraîchissez les tables et essayez à nouveau.",
  "extra181": "Vente non trouvée pour cette table occupée. Rafraîchissez les tables et essayez à nouveau.",
  "extra182": "Cette table a déjà une vente ouverte. Rafraîchissez les tables et ouvrez la vente existante.",
  "extra183": "La table occupée manquait un id de vente et la récupération a échoué. Rafraîchissez les tables et essayez à nouveau.",
  "extra184": "POS session expirée. Veuillez de nouveau déverrouiller ce terminal.",
  "extra185": "Cette table est servie par une salle à manger commune, mais ce terminal n'a pas été autorisé à accéder à la vente.",
  "extra186": "POS session expired or unauthorized. Re-enter OTP et essayez à nouveau.",
  "extra187": "Impossible d'ouvrir la table. Vérifiez la connectivité et essayez à nouveau.",
  "extra188": "Paiement échoué. Entrée ou choisissez une autre méthode.",
  "extra189": "Ce membre n'a pas de frais de compte activés.",
  "extra190": "Veuillez sélectionner un membre avant de recharger un compte.",
  "extra191": "Un membre n'a pas pu être trouvé.",
  "extra192": "Quelque chose s'est mal passé.",
  "extra193": "Plusieurs éléments correspondent à ce code-barres",
  "extra194": "Code barre non reconnu",
  "extra195": "Sélectionnez une table pour commencer.",
  "extra196": "Tapez les articles de menu pour commencer une vente.",
  "extra197": "Envoyé à la cuisine",
  "extra198": "Envoyer à la cuisine",
  "extra199": "Vente à découvert",
  "extra200": "Confirmez l'envoi",
  "extra201": "Terminal pOS",
  "extra202": "Se connecter",
  "extra203": "POS est hors ligne. Vérifiez la connectivité et essayez à nouveau.",
  "extra204": "Plan de plancher ne pouvait pas être chargé. Les carreaux sont toujours disponibles.",
  "extra206": "Le NIP est ambigu, demandez au gestionnaire de réinitialiser un NIP.",
  "extra207": "PIN non reconnu pour cette sortie.",
  "extra208": "Impossible de vous connecter. Vérifiez la connectivité et essayez à nouveau.",
  "extra209": "Impossible de lancer une nouvelle vente. Vérifiez la connectivité et essayez à nouveau.",
  "extra210": "Incapable d'ajouter l'élément. Connexion perdue.",
  "extra211": "Vente non prête",
  "extra212": "Incapable de supprimer l'élément. Connexion perdue.",
  "extra213": "Impossible de mettre à jour la quantité. Connexion perdue.",
  "extra214": "Incapable à la vente libre. Connexion perdue.",
  "extra215": "Enregistrement du paiement en espèces...",
  "extra216": "Paiement réussi",
  "extra217": "Lecteur déconnecté. Reconnecter et réessayer.",
  "extra220": "Aucun lecteur n'est enregistré pour cet emplacement dans Stripe .",
  "extra221": "Pas de lecteur simulé disponible. Activer le lecteur simulé et la rentrée.",
  "extra222": "Emplacement du terminal non configuré pour cette sortie.",
  "extra224": "Stripe Terminal SDK est des méthodes de paiement manquantes. Recharger le terminal et la rentrée.",
  "extra225": "Le lecteur est occupé. Déconnecter la session active et la rentrée.",
  "extra228": "Impossible de se connecter au lecteur. Vérifiez le réseau ou redémarrez le lecteur.",
  "extra229": "Le compte de recettes POS n'est pas configuré pour cet article/club.",
  "extra230": "La carte a diminué.",
  "extra231": "Ne pouvait pas se connecter à Stripe Terminal. Vérifiez le réseau et essayez à nouveau.",
  "extra232": "Sélectionnez une table avant d'envoyer à la cuisine.",
  "extra233": "Envoyer à la cuisine...",
  "extra234": "Déjà envoyé à la cuisine.",
  "extra235": "Envoyé à la cuisine.",
  "extra237": "Préparer le lecteur...",
  "extra238": "Connecter le lecteur...",
  "extra239": "Cette sortie n'a pas Stripe Emplacement du terminal configuré.",
  "extra240": "Découverte de lecteurs simulés...",
  "extra241": "Découverte du lecteur...",
  "extra242": "Pas de lecteur simulé disponible.",
  "extra243": "Se connecter au lecteur...",
  "extra244": "Stripe Terminal SDK méthodes de paiement manquantes.",
  "extra245": "Recueillir le mode de paiement...",
  "extra246": "L'intention de paiement manque.",
  "extra247": "Paiement de traitement...",
  "extra248": "Le traitement des paiements a échoué.",
  "extra249": "Postes approuvés",
  "extra250": "Sélectionnez un membre à facturer.",
  "extra251": "Compte de membre de charge...",
  "extra252": "Ajouté au compte membre",
  "extra253": "Les frais de compte des membres ont échoué. Retry ou choisir une autre méthode.",
  "extra254": "Impossible d'appliquer le membre. Essayez de nouveau.",
  "extra255": "Vente pas encore prête. Essayez encore.",
  "extra256": "Le membre n'a pas trouvé. Vérifiez le nombre et essayez à nouveau.",
  "extra257": "Incapable d'enlever le membre. Essayez à nouveau.",
  "extra258": "Incapable à la table désaffectée. Connexion perdue.",
  "extra259": "Prêt",
  "extra260": "Pas de table sélectionnée",
  "extra261": "Tapez pour ajouter · Maintenir pour les modificateurs",
  "extra262": "Disponible",
  "extra263": "Utilisez le code-barres/recherche à partir des outils terminaux.",
  "extra264": "Bientôt",
  "extra265": "Comptabilité",
  "extra266": "Modèles",
  "extra267": "Bibliothèque",
  "extra268": "Propriétés",
  "extra269": "Modèle d'écran POS premium touch-first.",
  "extra270": "Toutes les sorties",
  "extra271": "Non assigné",
  "extra272": "Ce modèle n'est actuellement attribué à aucun point de vente.",
  "extra273": "Produit manquant",
  "extra274": "Produit",
  "extra275": "Bouton",
  "extra276": "Créez ou sélectionnez un modèle avant d'utiliser Privana Assist.",
  "extra277": "Privana Assist peut seulement mettre à jour des modèles de projet. Dupliquer ce modèle pour créer une version modifiable.",
  "extra278": "Décrivez une mise en page; aucun changement d'écran POS en direct jusqu'à ce que vous l'examinez et l'appliquez.",
  "extra280": "Continuer",
  "extra281": "Quel type de sortie concevez-vous ?",
  "extra282": "On dirait bien.",
  "extra284": "Privana conçu cette mise en page",
  "extra285": "Mis à jour",
  "extra286": "Nouveau",
  "extra287": "Appliquer atomiquement...",
  "extra288": "Utilisez cette mise en page",
  "extra289": "Proposition prête à être examinée.",
  "extra290": "Privana L'aide a été annulée ou supprimée. Votre modèle est inchangé.",
  "extra291": "Privana L'aide n'a pas pu préparer une proposition sûre. Votre modèle est inchangé.",
  "extra292": "Privana Génération d'assistance annulée. Votre modèle est inchangé.",
  "extra293": "La proposition n ' a pas été annulée.",
  "extra294": "La proposition ne peut être annulée avant la régénération.",
  "extra295": "La proposition n'a pas pu être annulée avant de modifier les produits.",
  "extra296": "Layout appliqué. Le modèle reste un projet jusqu'à ce que vous le publiiez.",
  "extra297": "La proposition n ' a pas pu être appliquée et aucune modification n ' a été apportée.",
  "extra307": "Affecté",
  "extra308": "Hérités mondiales",
  "extra309": "De l ' effondrement",
  "extra312": "Aucun modèle sélectionné",
  "extra313": "Créer une page",
  "extra315": "Pas de modèle",
  "extra316": "Entrez un code à temps du gestionnaire",
  "extra317": "Code de vérification...",
  "extra318": "Accès aux terminaux requis",
  "extra319": "Membre attaché",
  "extra320": "Je regarde...",
  "extra321": "Appliquer",
  "extra331": "Généralités",
  "extra332": "Zone d ' essai",
  "extra334": "Tableau",
  "extra340": "Plan d'étage pas encore mis en place. Utilisez la gestion du repas pour en créer un.",
  "extra345": "Plan d ' aménagement",
  "search": "Cherche...",
  "outletTypes": {
    "bar": "Bar",
    "dining": "Salle à manger",
    "pro_shop": "Pro Shop",
    "halfway_house": "Maison à mi-chemin"
  },
  "setupModes": {
    "stock_only": "Stock seulement",
    "simple_product": "Produit simple acheté et vendu as-is",
    "draft_beer": "Bière de bureau / boisson mesurée",
    "food_recipe": "Recette / article alimentaire"
  },
  "actions": {
    "open_tables": "Tables ouvertes",
    "search_products": "Recherche produits",
    "member_lookup": "Contrôle de l ' adhésion",
    "open_tabs": "Ouvrez les onglets",
    "discounts": "Réductions",
    "refunds": "Remboursements",
    "transfer_table": "Tableau de transfert",
    "split_bill": "Facture partagée",
    "print_bill": "Imprimer la facture"
  },
  "dynamic": {
    "todays_specials": "Les spécialités d'aujourd'hui",
    "happy_hour": "Heure heureuse articles",
    "top_sellers": "Top vendeurs",
    "recently_sold": "Récemment vendus",
    "low_stock": "Faible stock"
  },
  "devices": {
    "tablet10": "10 pouces tablet",
    "terminal15": "Terminal de 15 pouces",
    "desktop": "Terminal de bureau",
    "landscapeTablet": "Tablette de paysage"
  },
  "statuses": {
    "open": "Ouvert",
    "pending": "En attente",
    "pending_payment": "Versement en attente",
    "sent_to_kitchen": "Envoyé à la cuisine",
    "unpaid": "Non payé",
    "paid": "Payé",
    "completed": "Terminé",
    "void": "Annulé",
    "voided": "Annulés",
    "refunded": "Remboursé",
    "partially_refunded": "Remboursés partiellement",
    "cancelled": "Annulé",
    "failed": "Échec",
    "processing": "Traitement",
    "succeeded": "Succeed",
    "active": "Actif",
    "inactive": "Inactif",
    "draft": "Brouillon",
    "published": "Publiée",
    "archived": "Archivé",
    "standard": "Norme standard",
    "enhanced": "Améliorés",
    "cash": "Encaisse",
    "card": "Carte",
    "card_present": "Carte présente",
    "member_account": "Compte membre",
    "member_charge": "Frais de membre",
    "consumed": "Consommation",
    "settled": "Réglé",
    "partially_paid": "Partiellement payé",
    "closed": "Fermé",
    "posted": "Comptabilisé",
    "not_posted": "Non posté",
    "not_required": "Non requis",
    "sale": "Vente",
    "refund": "Remboursement",
    "pos_sale": "Vente de SPFO",
    "pos_void": "Pos null",
    "pos_refund": "Remboursement POS",
    "warning": "Attention",
    "applied": "Appliquée",
    "deducted": "Déducted",
    "not_costed": "Non coûté",
    "pending_cost": "Coûts en attente",
    "reversed": "Extourné",
    "partially_settled": "Partiellement réglé",
    "authorized": "Autorisé",
    "sent": "Envoyé",
    "partially_sent": "Partiellement envoyé",
    "build": "Construction",
    "improve": "Améliorer",
    "partial": "Partiel"
  },
  "units": {
    "each": "chacun",
    "ml": "ml",
    "L": "L",
    "g": "g",
    "kg": "kg",
    "bottle": "bouteille",
    "case": "Cas",
    "keg": "keg",
    "barrel": "bar",
    "packages": "paquets",
    "package": "paquet",
    "stock": "stock"
  },
  "runtime": {
    "noItems": "Aucun menu n'a été configuré.",
    "searchHelp": "Recherchez tous les produits actifs pour ce club et ajoutez directement à la vente actuelle.",
    "searchPlaceholder": "Rechercher des boissons, de la nourriture, du détail...",
    "searchUnavailable": "Cherchez indisponible. Essayez encore.",
    "searching": "Cherchant...",
    "noMatches": "Aucun produit correspondant.",
    "startTyping": "Commencez à taper sur des produits de recherche.",
    "search": "Rechercher",
    "home": "Maison",
    "folder": "Dossier",
    "emptyPage": "Cette page conçue n'a pas encore de boutons.",
    "emptyFolder": "Ce dossier n'a pas encore de boutons.",
    "unavailable": "Cette fonction n'est pas encore disponible.",
    "unavailableLabel": "{label} , à venir bientôt, indisponible",
    "codeDigit": "Numéro de code {digit}"
  },
  "recipe": {
    "packaged": "{name} est stocké comme {size} {packageUnit} {unit} ; l'utilisation de la recette peut être saisie en {units} .",
    "incompatible": "{name} utilise {unit} ; choisissez une unité compatible."
  },
  "messages": {
    "orderCheck": "Commande/vérification",
    "tableMemberGuest": "Table/membre/invité",
    "defaultMenu": " • Menu par défaut: {name}",
    "default": "Par défaut {name}",
    "assignedCount": "Attribué à {count} sortie(s)",
    "stocked": "Stocké {size} {packageUnit} {unit}",
    "removeStaff": "Retirer {name} de ePOS? Leur compte de personnel de base restera actif.",
    "linkedOne": "Ce produit est relié un à un avec {name} .",
    "schema": "Le schéma produit/recipe ePOS est toujours en cours de migration.",
    "genericError": "Incapable de compléter cette action. Veuillez réessayer.",
    "unassign": "Tableau de désaffectation {name}",
    "clearing": "Déverrouillage...",
    "sending": "Envoi…",
    "checking": "Vérifie...",
    "added": "Ajouté {name}",
    "kitchenNotified": "Envoyé à la cuisine · {count} station(s) notifiée.",
    "kitchenFailed": "Impossible de prévenir la cuisine. Vérifiez la connectivité et essayez à nouveau.",
    "table": "Tableau {name}",
    "seats": "Places : {count}",
    "generating": "Generating...",
    "select": "Sélectionnez {name}",
    "templateAssigned": "Ce modèle est actuellement assigné à {count} cession(s): {names} .",
    "thinkRetail": "Je pense que vous concevez un {name}.",
    "designedRetail": "Privana a conçu cet écran pour un {name}",
    "pageNumber": "Page {number}",
    "deletePage": "Supprimer {name} ? {count} bouton(s) de dossier ( {folders} ) actuellement ouvrir cette page conçue. Si vous continuez, ces dossiers tomberont dans leur mise en page automatique enfant-noe.",
    "openPanel": "Ouvrir {name} panneau",
    "showSummary": "Voir le résumé {name}",
    "unlinked": "{name} non lié",
    "selectTable": "Sélectionnez le tableau {name}",
    "sku": "SKU {sku}",
    "taxRate": "Taxes {rate}",
    "unitsOr": " ou ",
    "recipeQty": " / Recette {quantity} {unit}"
  },
  "tax": {
    "noCode": "Pas de code fiscal",
    "loading": "Charger les codes fiscaux...",
    "select": "Sélectionnez le code fiscal",
    "unavailable": "Codes fiscaux non disponibles"
  },
  "retail": {
    "golf_pro_shop": "Boutique de golf",
    "main_bar": "Barre principale",
    "restaurant": "Restaurant",
    "halfway_house": "Maison à mi-chemin",
    "coffee_shop": "Café",
    "spa_retail": "Boutique du spa",
    "golf_academy": "Académie de golf",
    "tennis_shop": "Magasin de tennis",
    "padel_shop": "Boutique de padel",
    "fitness_reception": "Réception de la condition physique",
    "marina_shop": "Boutique de marina",
    "generic_retail": "Générique Retail",
    "other": "Autre"
  },
  "priorities": {
    "Fast checkout": "Paiement rapide",
    "Repeat purchases": "Répéter les achats",
    "Premium equipment browsing": "Navigation de l ' équipement Premium",
    "Upselling accessories": "Accessoires de vente",
    "Fast service": "Service rapide",
    "Popular drinks": "Boissons populaires",
    "Simple staff navigation": "Navigation simple du personnel",
    "Fast table ordering": "Commande de table rapide",
    "Clear courses": "Cours clairs",
    "Add-on visibility": "Visibilité Add-on",
    "Grab-and-go purchases": "Achats d ' accumulateurs et de marchandises",
    "Drink customisation": "Personnalisation des boissons",
    "Food add-ons": "Compléments alimentaires",
    "Premium presentation": "Présentation de prime",
    "Simple product discovery": "Simple découverte de produit",
    "Fast booking": "Réservation rapide",
    "Clear coaching options": "Options de coaching claires",
    "Equipment browsing": "Navigation des équipements",
    "Essential supplies": "Fournitures essentielles",
    "Clear categories": "Catégories claires"
  },
  "objectives": {
    "Fastest Checkout": "Checkout le plus rapide",
    "Increase Retail Sales": "Augmentation des ventes de détail",
    "Premium Merchandising": "Prime Merchandising",
    "Self-Service Friendly": "Auto-service Friendly",
    "Fast Staff Training": "Formation rapide du personnel"
  },
  "metrics": {
    "Pages affected": "Pages touchées",
    "New pages": "Nouvelles pages",
    "Updated pages": "Pages mises à jour",
    "New folders": "Nouveaux dossiers",
    "Unique products": "Produits uniques",
    "Home shortcuts": "Shortcuts à domicile",
    "Actions": "Actions",
    "Deletions": "Suppressions"
  },
  "fragments": {
    "message0": "{v0} recherche",
    "message1": "Par défaut {v0}",
    "message2": " • Menu par défaut: {v0}",
    "message3": "Attribué à la sortie {v0} {v1}",
    "message4": "SKU {v0}",
    "message5": "Taxes {v0}",
    "message6": "Ce produit est relié un à un avec {v0} .",
    "message7": "Tableau de désaffectation {v0}",
    "message8": "Ajouté {v0}",
    "message9": "{v0} Tableau {v1}",
    "message10": "Places : {v0}",
    "message11": "Ce modèle est actuellement assigné à {v0} cession de sortie {v1} : {v2} .",
    "message12": "Supprimer {v0} ? {v1} dossier bouton {v2} ( {v3} ) actuellement ouvrir cette page conçue. Si vous continuez, ces dossiers tomberont dans leur mise en page auto enfant-node.",
    "message13": "Ouvrir {v0} panneau",
    "message14": "{v0} , à venir bientôt, indisponible",
    "message15": "Voir le résumé {v0}",
    "message16": "{v0} non lié",
    "message17": "Sélectionnez le tableau {v0}",
    "message18": "Tableau {v0}"
  },
  "nodeTypes": {
    "product": "Produit",
    "folder": "Dossier",
    "action": "Action",
    "dynamic": "Dynamique"
  }
};
